import { render } from "./CategoriaPage.vue?vue&type=template&id=0429a3f0&scoped=true"
import script from "./CategoriaPage.vue?vue&type=script&lang=js"
export * from "./CategoriaPage.vue?vue&type=script&lang=js"

import "./CategoriaPage.vue?vue&type=style&index=0&id=0429a3f0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\musta\\Área de Trabalho\\Projetos\\catalogo\\catalogo-pedidos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0429a3f0"]])

export default __exports__